export default {
  settings: {
    title: "Impostazioni",
    subtitle: "Gestisci il tuo account e le preferenze",
    nav: {
      profile: "Il mio Profilo & Partner",
      wedding: "Dettagli Matrimonio",
      event: "Dettagli Evento",
      collaborators: "Collaboratori",
      notifications: "Notifiche",
      appearance: "Aspetto e Lingua",
      subscription: "Abbonamento",
      security: "Sicurezza"
    },
    groups: {
      account: "Account",
      event: "Evento",
      preferences: "Preferenze"
    },
    general: {
      title: "Il mio Profilo & Partner",
      description: "Gestisci le tue informazioni personali e quelle del tuo partner.",
      me: "Io",
      partner: "Il mio Partner",
      partnerHelp: "Invita il tuo partner a partecipare alla gestione del matrimonio."
    },
    wedding: {
      title: "Dettagli Matrimonio",
      description: "Informazioni essenziali sul tuo evento."
    },
    appearance: {
      title: "Aspetto & Lingua",
      description: "Personalizza la tua esperienza.",
      languages: {
        fr: "Francese",
        en: "Inglese",
        es: "Spagnolo",
        de: "Tedesco",
        it: "Italiano"
      }
    },
    notifications: {
      email: {
        title: "Notifiche via email",
        description: "Ricevi aggiornamenti importanti e promemoria via email"
      },
      push: {
        title: "Notifiche push",
        description: "Ricevi avvisi in tempo reale sul tuo browser"
      },
      title: "Notifiche",
      description: "Scegli come e quando vuoi ricevere notifiche.",
      enable: "Abilita notifiche",
      enableDesc: "Ricevi avvisi per eventi importanti",
      types: "Tipi di notifica",
      reminderTiming: "Tempo di promemoria predefinito",
      hoursBefore: "{{count}}h prima",
      quietHours: "Ore di silenzio",
      start: "Inizio",
      end: "Fine",
      labels: {
        tasks: "Attività",
        guests: "Invitati",
        budget: "Budget",
        system: "Sistema"
      },
      error: "Errore durante il caricamento delle impostazioni di notifica"
    },
    security: {
      title: "Sicurezza",
      description: "Gestisci la tua password e le sessioni.",
      status: "Stato dell'account",
      verified: "La tua email è verificata.",
      unverified: "La tua email non è verificata.",
      sessions: "Sessioni attive",
      dangerZone: "Zona pericolosa",
      deleteAccount: "Elimina account",
      deleteAccountHelp: "Questa azione è irreversibile."
    },
    collaborators: {
      title: "Gestione della condivisione",
      invitationsTitle: "Inviti di condivisione",
      noWedding: "Nessun matrimonio trovato",
      loadError: "Si è verificato un errore durante il caricamento del matrimonio",
      invitationsError: "Si è verificato un errore durante il caricamento degli inviti",
      noInvitations: "Nessun invito trovato",
      noInvitationsDesc: "Gli inviti di condivisione appariranno qui una volta creati",
      expiresAt: "Scade il: {{date}}",
      accessCode: "Codice di accesso: {{code}}",
      infoMessage: "Questa pagina mostra gli inviti di condivisione inviati. Per creare nuovi inviti o gestire i collaboratori, utilizza il componente ShareManagement nelle impostazioni del tuo evento.",
      status: {
        pending: "In attesa",
        accepted: "Accettata",
        declined: "Rifiutata",
        expired: "Scaduta"
      },
      resourceTypes: {
        tasks: "Attività",
        guests: "Invitati",
        budget: "Budget",
        timeline: "Timeline",
        tasksAndGuests: "Attività e Invitati"
      }
    },
    subscription: {
      title: "Abbonamento & Fatturazione",
      description: "Gestisci il tuo piano e monitora il tuo utilizzo.",
      invoices: "Fatture",
      noInvoices: "Nessuna fattura disponibile",
      upgrade: "Passa a Premium",
      features: {
        oneEvent: "1 Evento",
        basicGuests: "Lista invitati base",
        limitedTasks: "Attività limitate",
        unlimitedEvents: "Eventi illimitati",
        unlimitedGuests: "Invitati illimitati",
        export: "Esportazione PDF & Excel",
        seating: "Piano tavoli avanzato",
        budget: "Budget & Analisi",
        support: "Supporto prioritario"
      },
      proDescription: "Goditi tutte le funzionalità senza limiti.",
      freeDescription: "Passa a Premium per sbloccare tutte le funzionalità."
    },
    theme: "Tema",
    placeholders: {
      exampleName: "Es: Maria Rossi",
      exampleVenue: "Es: Grand Hotel"
    },
    language: "Lingua",
    languageDescription: "Scegli la lingua dell'interfaccia",
    account: {
      export: {
        button: "Esporta i miei dati",
        loading: "Esportazione in corso..."
      },
      errors: {
        exportData: "Errore durante l'esportazione dei dati",
        deleteAccount: "Errore durante l'eliminazione dell'account"
      }
    },
    export: {
      title: "Esporta i miei dati",
      description: "Scarica una copia di tutti i tuoi dati (ospiti, attività, budget, ecc.)",
      gdprNotice: "In conformità con il GDPR, puoi recuperare tutti i tuoi dati personali."
    },
    delete: {
      title: "Elimina il mio account",
      description: "Questa azione è irreversibile. Tutti i tuoi dati saranno eliminati definitivamente.",
      confirmTitle: "Eliminare il mio account?",
      confirmDescription: "Sei sicuro di voler eliminare definitivamente il tuo account? Tutti i tuoi dati andranno persi.",
      confirmButton: "Elimina definitivamente"
    },
    firstName: "Nome",
    lastName: "Cognome",
    email: "Email",
    partnerName: "Nome completo",
    partnerEmail: "Email (per invito)",
    weddingDate: "Data del matrimonio",
    location: "Luogo & Posizione",
    venue: "Luogo del ricevimento",
    country: "Paese",
    city: "Città",
    guestCount: "Numero stimato di invitati",
    password: "Password",
    passwordHelp: "Ultima modifica 3 mesi fa",
    changePassword: "Modifica",
    currentPassword: "Password attuale",
    newPassword: "Nuova password"
  }
};